<template>
  <div class="create-batch-check-order-job" key="0">
    <a-spin :spinning="isLoading">
      <div class="content" style="min-height: 0; padding-bottom: 0; margin-bottom: 0">
        <a-tabs default-active-key="OrderStatusFlow" @change="changeTabs">
          <a-tab-pane
            v-if="isEdit"
            key="OrderStatusFlow"
            :tab="$t(`form.OrderStatusFlow`)"
          ></a-tab-pane>
          <a-tab-pane key="InboundDetail" :tab="$t(`form.InboundDetail`)"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`form.ProductInfo`)"></a-tab-pane>
        </a-tabs>
      </div>
      <div class="content-overflow mt10">
        <section class="left-div fixContent mr10">
          <a-form-model ref="ruleForm" :model="formData" :rules="rules">
            <div v-if="isEdit" id="OrderStatusFlow" class="modalBox">
              <div>
                <i class="leftLine"></i>
                <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                  {{ $t(`订单流转状态`) }}
                  <a-icon type="sync" class="text-main" @click="refreshHandle" />
                </span>
              </div>
              <div class="statusBox">
                <div class="title-sn">
                  <div style="font-size: 16px; font-weight: bold">
                    {{ $t(`预到货通知单号`) }}：{{ formData.advancedShippingNoteSn }}
                    <a-icon
                      class="text-link ml6"
                      type="copy"
                      @click="copy(formData.advancedShippingNoteSn)"
                    />
                    <a-tag style="font-size: 12px; font-weight: normal; margin-left: 10px">
                      {{ formData.status | statusFilter }}
                    </a-tag>
                    <a-tag
                      style="font-size: 12px; font-weight: normal; margin-left: 10px"
                      color="blue"
                    >
                      {{ formData.asnType | asnTypeFilter }}
                    </a-tag>
                  </div>
                  <div class="sub-title-sn">
                    <div>
                      {{ $t(`form.AssociatedDocNo`) }}：{{ formData.associatedOrderSn }}
                      <a-icon
                        class="text-link ml6"
                        type="copy"
                        @click="copy(formData.associatedOrderSn)"
                      />
                    </div>
                    <div v-if="formData.receivingOrderSn">
                      {{ $t(`入库单号`) }}：{{ formData.receivingOrderSn }}
                      <a-icon
                        class="text-link ml6"
                        type="copy"
                        @click="copy(formData.receivingOrderSn)"
                      />
                    </div>
                    <div v-if="formData.referenceNo">
                      {{ $t(`跟踪单号`) }}：{{ formData.referenceNo }}
                      <a-icon
                        class="text-link ml6"
                        type="copy"
                        @click="copy(formData.referenceNo)"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="formData.status && formData.status !== 'CANCEL'">
                  <a-button
                    v-if="
                      formData.asnType == 'PURCHASE' &&
                      !isShow &&
                      !isInfoShow &&
                      formData.status === 'WAIT_CHECK'
                    "
                    type="primary"
                    :loading="reviewLoading"
                    @click="onReview"
                  >
                    {{ $t(`form.Review`) }}
                  </a-button>
                  <!-- <a-button
                    v-if="
                      formData.asnType == 'PURCHASE' &&
                      !isShow &&
                      !isInfoShow &&
                      formData.status &&
                      formData.status == 'PART_INBOUND'
                    "
                    type="primary"
                    :loading="confirmFinishLoading"
                    @click="onConfirmFinish"
                  >
                    {{ $t(`form.ConfirmFinish`) }}
                  </a-button> -->
                  <a-button
                    v-if="
                      formData.asnType == 'PURCHASE' &&
                      ((!isShow &&
                        !isInfoShow &&
                        formData.status &&
                        formData.status == 'WAIT_PUSH') ||
                        formData.status == 'WAIT_INBOUND' ||
                        formData.status == 'PUSH_FAIL')
                    "
                    :loading="withdrawalLoading"
                    @click="onWithdrawal"
                    type="primary"
                  >
                    {{ $t(`form.Withdrawal`) }}
                  </a-button>
                  <a-button
                    v-if="
                      formData.asnType == 'PURCHASE' &&
                      !isShow &&
                      !isInfoShow &&
                      formData.status &&
                      (formData.status == 'WAIT_CHECK' ||
                        formData.status == 'WAIT_INBOUND' ||
                        formData.status == 'PUSH_FAIL' ||
                        formData.status == 'WAIT_PUSH')
                    "
                    type="danger"
                    :loading="voidOrderLoading"
                    @click="onVoidOrder"
                  >
                    {{ $t(`form.VoidOrder`) }}
                  </a-button>
                  <a-button
                    v-if="
                      (formData.warehousePlatform == 'VIRTUAL_WMS' ||
                        formData.warehousePlatform == 'OMS') &&
                      (formData.status === 'WAIT_INBOUND' || formData.status === 'PART_INBOUND') &&
                      isEdit &&
                      !isInfoShow
                    "
                    type="primary"
                    @click="onManualImport"
                  >
                    {{ $t(`form.ManualImport`) }}
                  </a-button>
                  <a-button
                    v-if="
                      (formData.warehousePlatform == 'VIRTUAL_WMS' ||
                        formData.warehousePlatform == 'OMS') &&
                      (formData.status === 'WAIT_INBOUND' || formData.status === 'PART_INBOUND') &&
                      isEdit &&
                      isInfoShow
                    "
                    :loading="confirmWarehousingLoading"
                    @click="onConfirmWarehousing"
                    type="primary"
                  >
                    {{ $t(`form.ConfirmWarehousing`) }}
                  </a-button>
                  <a-button
                    v-if="
                      (formData.warehousePlatform == 'VIRTUAL_WMS' ||
                        formData.warehousePlatform == 'OMS') &&
                      (formData.status === 'WAIT_INBOUND' || formData.status === 'PART_INBOUND') &&
                      isEdit &&
                      isInfoShow
                    "
                    @click="cancelInfoEdit"
                    type="danger"
                  >
                    {{ $t(`form.Cancel`) }}
                  </a-button>
                </div>
              </div>
              <component
                v-if="stateData.length > 0"
                :is="'process-state2'"
                :statedata="stateData"
                :curstate="curState"
                :style-obj="{ stateItem: 130 }"
              ></component>
            </div>
            <div id="InboundDetail" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t(`form.InboundDetail`) }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <div>
                <a-row class="flex-row">
                  <a-col :span="7" style="margin-right: 4%; position: relative" v-if="!isEdit">
                    <a-form-model-item :required="true" :label="$t(`采购单号`)">
                      <a-select
                        allowClear
                        style="width: 100%"
                        :placeholder="$t(`采购单号`)"
                        v-model="formData.associatedOrderSn"
                        @change="purchaseOrderSnChange"
                        show-search
                        :default-active-first-option="false"
                        :filter-option="false"
                        :options="orderSnList"
                        :not-found-content="null"
                        @search="purchaseOrderSnSearch"
                        :getPopupContainer="
                          (triggerNode) => {
                            return triggerNode.parentNode
                          }
                        "
                      ></a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`预计到货时间`)">
                      <div style="display: flex; align-items: center">
                        <DatePicker
                          :needhms="true"
                          style="background-color: #ffffff; flex: 1"
                          :init-date-time="formData.estimatedArrivalTime"
                          @choose="chooseEstimatedArrivalTime"
                          :disabled="isEdit ? !isEditingEstimatedArrivalTime : false"
                          :placehold="$t(`预计到货时间`)"
                        />
                        <template v-if="isEdit">
                          <a-button
                            v-if="!isEditingEstimatedArrivalTime"
                            type="link"
                            size="small"
                            style="margin-left: 8px; padding: 0"
                            @click="startEditEstimatedArrivalTime"
                          >
                            {{ $t('修改') }}
                          </a-button>
                          <div
                            v-else
                            style="
                              display: flex;
                              align-items: center;
                              margin-left: 8px;
                              white-space: nowrap;
                            "
                          >
                            <a-button
                              type="link"
                              size="small"
                              :loading="updateEstimatedArrivalTimeLoading"
                              style="padding: 0 4px"
                              @click="saveEstimatedArrivalTime"
                            >
                              {{ $t('保存') }}
                            </a-button>
                            <a-button
                              type="link"
                              size="small"
                              style="padding: 0 4px; color: #999"
                              @click="cancelEditEstimatedArrivalTime"
                            >
                              {{ $t('取消') }}
                            </a-button>
                          </div>
                        </template>
                      </div>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`form.supplierName`)" :required="true">
                      <a-input
                        :disabled="Boolean(purchaseOrderSn) || isEdit"
                        v-model="formData.supplierName"
                        :placeholder="$t(`form.supplierName`)"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :required="true" :label="$t(`form.receiverWarehouse`)">
                      <SelectWarehouseNew
                        :placeholder="$t(`form.receiverWarehouse`)"
                        style="width: 100%"
                        :disabled="Boolean(purchaseOrderSn) || isEdit"
                        :code.sync="formData.warehouseCode"
                        @selected="selectedWarehouse"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`form.receiverAddress`)">
                      <a-input
                        :disabled="Boolean(purchaseOrderSn) || isEdit"
                        v-model="formData.receiverAddress"
                        :placeholder="$t(`form.receiverAddress`)"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`form.AssociatedBatchNumber`)">
                      <a-input
                        allow-clear
                        v-model.trim="formData.batchNo"
                        :placeholder="$t(`form.AssociatedBatchNumber`)"
                        :disabled="isEdit && (!isEdit || !isShow)"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`form.TypeOfShipping`)">
                      <a-select
                        allowClear
                        :placeholder="$t(`form.TypeOfShipping`)"
                        style="width: 100%"
                        v-model="formData.shippingMethod"
                        :disabled="isEdit && (!isEdit || !isShow)"
                      >
                        <a-select-option
                          v-for="item in shippingList"
                          :key="item.code"
                          :value="item.code"
                        >
                          {{ item.shippingName }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`运费`)">
                      <a-input
                        :disabled="isEdit && (!isEdit || !isShow)"
                        v-model="formData.shipFee"
                        :placeholder="$t(`运费`)"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7" style="margin-right: 4%">
                    <a-form-model-item :label="$t(`form.note`)">
                      <a-input
                        :disabled="isEdit && (!isEdit || !isShow)"
                        v-model="formData.note"
                        :placeholder="$t(`form.note`)"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col
                    :span="7"
                    style="margin-right: 4%"
                    v-if="formData.receivingOrderSn && !isEdit"
                  >
                    <a-form-model-item :label="$t(`入库单号`)">
                      <a-input
                        v-model="formData.receivingOrderSn"
                        :placeholder="$t(`入库单号`)"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col
                    :span="7"
                    style="margin-right: 4%"
                    v-if="formData.advancedShippingNoteSn && !isEdit"
                  >
                    <a-form-model-item :label="$t(`预到货通知单号`)">
                      <a-input
                        v-model="formData.advancedShippingNoteSn"
                        :placeholder="$t(`预到货通知单号`)"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-form-model>

          <div id="ProductInfo" class="modalBox">
            <a-form-model>
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  {{ $t('form.ProductInfo') }}
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isInfoShow = !isInfoShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="createInfoForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="cancelInfoEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
                <div class="txt">
                  <span style="margin-right: 30px">
                    {{ $t('预计到货数量') }}: {{ purchaseAllQuantity | toThousands }}
                  </span>
                  <span style="margin-right: 30px">
                    {{ $t('实际到货数量') }}: {{ receivedAllQuantity | toThousands }}
                  </span>
                  <span>
                    {{ $t('差异数量') }}:
                    {{ (receivedAllQuantity - purchaseAllQuantity) | toThousands }}
                  </span>
                </div>
              </div>
              <div v-if="formData.status !== '' && !isInfoShow">
                <a-row style="display: flex" :gutter="24">
                  <a-col :span="7">
                    <a-input :placeholder="$t(`layer.PleaseEnterRange`)" @change="selectCaseNo" />
                  </a-col>
                  <a-col :span="7">
                    <a-button type="primary" @click="showMarkModal">
                      {{ $t(`form.PrintshippingMark`) }}
                    </a-button>
                  </a-col>
                </a-row>
              </div>
              <a-row
                v-if="!editShow || (editShow && isInfoShow && formData.status === 'WAIT_CHECK')"
                style="display: flex"
              >
                <a-col style="position: relative; flex: 1">
                  <SearchSku style="width: 300px" @selected="handleChangeSku" />
                  <a-button type="primary" style="margin-left: 15px" @click="addGoodsToTable">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('form.Add') }}
                  </a-button>
                </a-col>
              </a-row>
              <a-row
                v-if="!editShow || (editShow && isInfoShow && formData.status === 'WAIT_CHECK')"
                style="margin: 8px 0; display: flex"
              >
                <a-col>
                  <a-button type="primary" @click="showModalFn">
                    {{ $t(`form.BatchImport`) }}
                  </a-button>
                </a-col>
                <a-col style="margin-left: 10px">
                  <a-button type="danger" @click="batchDelFn">
                    {{ $t(`form.BatchDelete`) }}
                  </a-button>
                </a-col>
              </a-row>
              <a-row
                v-if="
                  (formData.status === 'WAIT_INBOUND' || formData.status === 'PART_INBOUND') &&
                  (formData.warehousePlatform == 'VIRTUAL_WMS' ||
                    formData.warehousePlatform == 'OMS') &&
                  isEdit &&
                  isInfoShow
                "
                style="text-align: right"
              >
                <a-button @click="onWarehousingAll" type="primary">
                  {{ $t(`form.WarehousingAll`) }}
                </a-button>
                <a-button type="primary" @click="showModalQuantityFn">
                  {{ $t(`form.BatchReceiptQuantity`) }}
                </a-button>
              </a-row>
              <a-row>
                <div class="table-wrapper" style="margin-top: 10px">
                  <!--每个列的宽度必须比列名总长度大才能使表格所有列对齐，留一个列不设置宽度  :rowSelection="{selectedRowKeys: selectedRowKeys}"-->
                  <!-- formData.status === 'WAIT_CHECK' -->
                  <a-table
                    :columns="showColumns"
                    :dataSource="tableData"
                    bordered
                    size="middle"
                    :loading="tableLoading"
                    :pagination="false"
                    :scroll="{ x: 'max-content' }"
                    :row-selection="{
                      selectedRowKeys: selectedRowKeys,
                      onChange: onSelectChange,
                    }"
                    :rowKey="
                      (record, index) => {
                        return index
                      }
                    "
                  >
                    <span slot="BoxNumber">
                      <i class="red">*</i>
                      &nbsp;{{ $t(`form.BoxNumber`) }}
                    </span>
                    <span slot="ProductBarcode">
                      <i class="red">*</i>
                      &nbsp;{{ $t(`form.ProductBarcode`) }}
                    </span>
                    <span slot="SkuNumber">
                      {{ $t(`form.skuNumber`) }}
                    </span>
                    <span slot="StockQuantity">
                      <i class="red">*</i>
                      &nbsp;{{ $t(`form.StockQuantity`) }}
                    </span>
                    <span slot="CommoditySpecification">
                      {{ $t(`form.CommoditySpecification`) }}
                    </span>
                    <span slot="Unit">{{ $t(`form.Unit`) }}</span>
                    <span slot="Remark">{{ $t(`form.Remark`) }}</span>
                    <span slot="Operation">{{ $t(`form.Operation`) }}</span>
                    <span slot="titleValue" class="form-table-heard">
                      {{ $t('form.TotalQuantity') }}
                    </span>
                    <span slot="titleValue2" class="form-table-heard">
                      {{ $t('form.PurchasePrice') }}
                    </span>
                    <template slot="DifferentCount" slot-scope="text, record">
                      {{ getDiffCount(record) }}
                    </template>
                    <template slot="shipFiles" slot-scope="text, record">
                      <span v-if="record.shipFiles && record.shipFiles.length">
                        <ImagePreview :imageList="record.shipFiles">
                          <span class="text-link">{{ $t('入库附件') }}</span>
                        </ImagePreview>
                      </span>
                      <span v-else>{{ $t('暂无附件') }}</span>
                      <a-button
                        type="link"
                        v-if="
                          isRent &&
                          (+record.putAwayDefectiveQuantity + +record.putAwayQuantity === 0 ||
                            formData.status === 'WAIT_INBOUND')
                        "
                        @click="openImeiModal(record)"
                      >
                        维护串码/上传附件
                      </a-button>
                    </template>
                    <template slot="purchaseUnitPrice" slot-scope="text">
                      <PriceInput :value="text" :showTxt="true" v-if="text !== undefined" />
                      <span v-else>-</span>
                    </template>

                    <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                      <div :key="col">
                        <div
                          v-if="isInfoShow"
                          style="display: flex; align-items: center; justify-content: center"
                        >
                          <a-input
                            :placeholder="$t('多个串码逗号或者空格隔开')"
                            v-if="col === 'imeiList'"
                            :value="text"
                            @change="(e) => handleChange(e.target.value, record.key, col, index)"
                          />
                          <!-- includes 用来判断当前的输入类型 -->
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :formatter="Formatter"
                            :parser="Formatter"
                            v-else-if="
                              inputScopedSlots.includes(col) &&
                              (col === 'caseNo' ||
                                col === 'sentQuantity' ||
                                col === 'putAwayQuantity' ||
                                col === 'putAwayDefectiveQuantity')
                            "
                            :min="0"
                            :value="text"
                            @change="(e) => handleChange(e, record.key, col, index)"
                          />
                          <a-input
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :value="text"
                            v-else-if="inputScopedSlots.includes(col)"
                            @change="(e) => handleChange(e.target.value, record.key, col, index)"
                          />
                          <a v-else-if="col === 'delect'" @click="onDelect(index)">
                            <a-icon type="delete" style="color: red" />
                          </a>
                          <div v-else-if="col === 'note'" style="text-align: left">
                            <template v-if="parseNote(text)">
                              <div v-if="parseNote(text).battery">
                                电池: {{ parseNote(text).battery }}
                              </div>
                              <div v-if="parseNote(text).appearance">
                                外观: {{ parseNote(text).appearance }}
                              </div>
                              <div v-if="parseNote(text).note">
                                备注: {{ parseNote(text).note }}
                              </div>
                            </template>
                            <template v-else>{{ text }}</template>
                          </div>
                          <span v-else>{{ text | toThousands }}</span>
                          <a-button
                            v-if="isRent && col === 'sentQuantity' && text > 1"
                            type="link"
                            style="padding: 0 4px; margin-left: 4px"
                            @click="handleSplit(index)"
                          >
                            单件拆分
                          </a-button>
                        </div>
                        <div
                          v-else
                          style="display: flex; align-items: center; justify-content: center"
                        >
                          <!-- includes 用来判断当前的输入类型 -->
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :formatter="Formatter"
                            :parser="Formatter"
                            v-if="
                              record.editable &&
                              inputScopedSlots.includes(col) &&
                              (col === 'caseNo' ||
                                col === 'sentQuantity' ||
                                col === 'putAwayQuantity' ||
                                col === 'putAwayDefectiveQuantity')
                            "
                            :value="text"
                            :min="0"
                            @change="(e) => handleChange(e, record.key, col, index)"
                          />
                          <a-input
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :value="text"
                            v-else-if="record.editable && inputScopedSlots.includes(col)"
                            @change="(e) => handleChange(e.target.value, record.key, col, index)"
                          />
                          <a v-else-if="col === 'delect'" @click="onDelect(index)">
                            <a-icon type="delete" style="color: red" />
                          </a>
                          <div v-else-if="col === 'note'" style="text-align: left">
                            <template v-if="parseNote(text)">
                              <div v-if="parseNote(text).battery">
                                电池: {{ parseNote(text).battery }}
                              </div>
                              <div v-if="parseNote(text).appearance">
                                外观: {{ parseNote(text).appearance }}
                              </div>
                              <div v-if="parseNote(text).note">
                                备注: {{ parseNote(text).note }}
                              </div>
                            </template>
                            <template v-else>{{ text }}</template>
                          </div>
                          <span v-else-if="col === 'imeiList'">{{ text }}</span>
                          <span v-else>{{ text | toThousands }}</span>

                          <a-button
                            v-if="isRent && record.editable && col === 'sentQuantity' && text > 1"
                            type="link"
                            style="padding: 0 4px; margin-left: 4px"
                            @click="handleSplit(index)"
                          >
                            单件拆分
                          </a-button>
                        </div>
                      </div>
                    </template>
                  </a-table>
                </div>
              </a-row>
            </a-form-model>
          </div>
        </section>
        <div class="right-div" v-if="orderActions.length">
          <section class="content">
            <p class="formContentGoods" style="margin: 0; padding: 0 0 10px 0">
              {{ $t('form.OperationLog') }}
            </p>
            <div style="width: 100%">
              <a-timeline class="formContentGoods">
                <a-timeline-item v-for="item in orderActions" :key="item.purchaseOrderActionId">
                  <p
                    v-html="item.content"
                    style="word-wrap: break-word; word-break: break-all; display: inline-block"
                  ></p>
                  <p v-if="item.createdAt" style="color: #999999">
                    {{ decodeURIComponent(item.createdUser) }} {{ item.createdAt }}
                  </p>
                </a-timeline-item>
              </a-timeline>
            </div>
          </section>
        </div>
      </div>
      <div class="content" style="min-height: 0" v-if="!isEdit">
        <a-row type="flex" justify="center">
          <a-col v-if="formData.status !== 'CANCEL'">
            <a-row type="flex" justify="start" :gutter="16">
              <a-button type="default" @click="backForm">{{ $t(`form.Back`) }}</a-button>
              <a-button
                v-if="editShow && formData.status == 'WAIT_CHECK'"
                type="primary"
                @click="onEdit"
              >
                {{ $t(`form.Edit`) }}
              </a-button>
              <a-button
                v-else-if="formData.status == 'WAIT_CHECK' || !formData.status"
                type="primary"
                :loading="submitLoading"
                @click="onSubmit"
              >
                {{ $t(`form.Save`) }}
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </div>
      <!-- 打印箱唛 -->
      <a-modal v-model="isShowMark" centered :title="$t(`form.PrintshippingMark`)">
        <template slot="footer">
          <a-button type="primary" key="impodtPdf" @click="exportPdf">
            {{ $t(`form.impodtPdf`) }}
          </a-button>
          <a-button key="preview" @click="previewPdf">
            {{ $t(`form.Preview`) }}
          </a-button>
          <a-button key="back" @click="isShowMark = false">
            {{ $t(`form.Close`) }}
          </a-button>
        </template>
        <div>
          <span style="display: block; padding-bottom: 7px">
            {{ $t(`form.PrintFormatSelection`) }}
          </span>
          <a-radio-group v-model="thermalPaper">
            <a-radio :value="'100 * 100'">{{ $t(`form.Thermalpaper`) }} (100*100)</a-radio>
            <a-radio :value="'100 * 150'">{{ $t(`form.Thermalpaper`) }} (100*150)</a-radio>
          </a-radio-group>
        </div>
      </a-modal>
      <!-- 导入预到货商品信息数据 -->
      <a-modal
        class="importModal"
        v-model="isImportData"
        :title="modalInfo.modalTitle"
        :width="500"
        :footer="null"
      >
        <div class="upload-content">
          <a-upload-dragger
            name="file"
            :headers="{ Authorization: sessionId }"
            @change="importData"
            :action="modalInfo.modalUrl + `?language=${this.language_mapping[this.lang]}`"
            :data="{
              warehouseCode:
                this.formData.warehouseCode == undefined ? '' : this.formData.warehouseCode,
              buId: buId,
            }"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="cloud-upload" />
            </p>
            <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
          </a-upload-dragger>
          <a
            v-if="modalInfo.xlsDownloadUrl"
            class="text-info mt10"
            download
            :href="modalInfo.xlsDownloadUrl"
          >
            {{ modalInfo.modalTitle }} {{ $t('form.Template') }}.xls
          </a>
        </div>
      </a-modal>
      <!-- 导入当前入库数量 -->
      <a-modal
        class="importModal"
        v-model="importQuantity"
        :title="modalInfoQuantity.modalTitle"
        :width="500"
        :footer="null"
      >
        <div class="upload-content">
          <a-upload-dragger
            name="file"
            :headers="{ Authorization: sessionId }"
            @change="importQuantityFn"
            :action="modalInfoQuantity.modalUrl + `?language=${this.language_mapping[this.lang]}`"
            :data="{
              warehouseCode:
                this.formData.warehouseCode == undefined ? '' : this.formData.warehouseCode,
              buId: buId,
            }"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="cloud-upload" />
            </p>
            <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
          </a-upload-dragger>
          <a
            v-if="modalInfoQuantity.xlsDownloadUrl"
            class="text-info mt10"
            download
            :href="modalInfoQuantity.xlsDownloadUrl"
          >
            {{ modalInfoQuantity.modalTitle }} {{ $t('form.Template') }}.xls
          </a>
        </div>
      </a-modal>
      <!-- 单条维护串码与入库图片 -->
      <a-modal
        v-model="imeiModalVisible"
        :confirmLoading="imeiModalSubmitting"
        :title="$t('维护串码与入库图片')"
        width="850px"
        :mask-closable="false"
        @ok="submitImeiModal"
        @cancel="imeiModalVisible = false"
      >
        <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-form-model-item :label="$t('串码')">
            <a-textarea
              v-model="imeiModalImeiInput"
              :rows="4"
              :placeholder="$t('多个串码逗号或者空格隔开')"
            />
          </a-form-model-item>
          <a-form-model-item :label="$t('电池')">
            <a-input v-model="imeiModalBattery" :placeholder="$t('请输入电池百分比')" />
          </a-form-model-item>
          <a-form-model-item :label="$t('外观')">
            <a-input v-model="imeiModalAppearance" :placeholder="$t('请输入外观情况')" />
          </a-form-model-item>
          <a-form-model-item :label="$t('备注')">
            <a-input v-model="imeiModalNote" :placeholder="$t('请输入备注')" />
          </a-form-model-item>
          <a-form-model-item :label="$t('入库附件')">
            <upload-image
              :multiple="99"
              :imageList.sync="imeiModalImageList"
              biz="asnShip"
              accept="image/*,video/*"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapState, mapGetters } from 'vuex'
import fetch from '@/service/fetch'
import { getCookie } from '@/common/cookie'
import processState2 from '@component/processState2'
import SearchSku from '@component/searchSku'
import DatePicker from '@component/datePicker'
import uploadImage from '@component/uploadImage'
import formatter from '@/common/formatter'
import deepClone from '@/common/deepClone'
import debounce from '@/common/debounce'
import ImagePreview from '@component/imagePreview'
import PriceInput from '@component/priceInput'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import { copy } from '@/common'
var _self = {}
let timeout
let currentValue = ''
export default {
  name: 'advancedShippingNoteDetail',
  components: {
    processState2,
    SearchSku,
    DatePicker,
    uploadImage,
    ImagePreview,
    PriceInput,
    SelectWarehouseNew,
  },

  data() {
    return {
      purchaseOrderId: '',
      editShow: false,
      isEdit: false,
      purchaseOrderSn: '',
      isShow: false,
      isInfoShow: false,
      orderActions: [],
      advancedShippingNoteId: '',
      stockColumns: [
        {
          align: 'center',
          dataIndex: 'caseNo',
          width: 120,
          slots: { title: 'BoxNumber' },
          scopedSlots: {
            customRender: 'caseNo',
          },
        },
        {
          title: this.$t('form.ProductName'),
          align: 'center',
          dataIndex: 'productName',
          width: 120,
          scopedSlots: {
            customRender: 'productName',
          },
          customCell: this.customCell,
        },
        {
          slots: { title: 'SkuNumber' },
          align: 'center',
          dataIndex: 'skuNumber',
          width: 120,
          scopedSlots: {
            customRender: 'skuNumber',
          },
        },
        {
          slots: { title: 'ProductBarcode' },
          align: 'center',
          dataIndex: 'barcode',
          width: 160,
          scopedSlots: {
            customRender: 'barcode',
          },
        },
        {
          slots: { title: 'CommoditySpecification' },
          align: 'center',
          dataIndex: 'productStyle',
          width: 160,
          scopedSlots: {
            customRender: 'productStyle',
          },
        },
        {
          align: 'center',
          dataIndex: 'sentQuantity',
          width: 120,
          slots: { title: 'StockQuantity' },
          scopedSlots: {
            customRender: 'sentQuantity',
          },
        },
        {
          title: this.$t('单价'),
          align: 'center',
          dataIndex: 'purchaseUnitPrice',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseUnitPrice',
          },
        },
        {
          title: this.$t('已入库(正品)'),
          align: 'center',
          dataIndex: 'putAwayQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'putAwayQuantity',
          },
        },
        {
          title: this.$t('已入库(次品)'),
          align: 'center',
          dataIndex: 'putAwayDefectiveQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'putAwayDefectiveQuantity',
          },
        },
        {
          title: this.$t(`form.DifferentCount`),
          align: 'center',
          dataIndex: 'differentCount',
          width: 120,
          scopedSlots: {
            customRender: 'DifferentCount',
          },
        },
        {
          slots: { title: 'Unit' },
          align: 'center',
          dataIndex: 'unit',
          width: 120,
          scopedSlots: {
            customRender: 'unit',
          },
        },
        {
          slots: { title: 'Remark' },
          align: 'center',
          dataIndex: 'note',
          width: 120,
          scopedSlots: {
            customRender: 'note',
          },
        },
        {
          slots: { title: 'Operation' },
          align: 'center',
          dataIndex: 'delect',
          width: 120,
          scopedSlots: {
            customRender: 'delect',
          },
        },
      ],
      // 表格数据
      tableData: [],
      customRenderList: [
        'caseNo',
        'caseUnit',
        'caseNum',
        'sentQuantity',
        'imeiList',
        'currency',
        'note',
        'unit',
        'delect',
        'skuNumber',
        'putAwayQuantity',
        'putAwayDefectiveQuantity',
      ],
      // 用来匹配插槽中显示input框
      inputScopedSlots: ['caseNo', 'caseNum', 'sentQuantity', 'imeiList', 'note', 'skuNumber'],
      // 用来匹配插槽中显示select框
      selectScopedSlots: ['caseUnit', 'currency', 'unit'],
      // 对于某些自动赋值的input框设为 只读
      readonlyArr: [''],
      // 表格loading
      tableLoading: false,
      // 表格选中key
      selectedRowKeys: [],
      provinceList: [],
      formData: {
        status: '',
      },
      selectedGoodsOrGroup: {},
      selectedGoodsOrGroupArray: [],
      rules: {
        Associated: [{ required: true, message: this.$t('请输入关联采购单号'), trigger: 'blur' }],
        Warehouse: [
          { required: true, message: this.$t('layer.PleaseReceivingWarehouse'), trigger: 'blur' },
        ],
      },
      isShowMark: false,
      orderSnList: [],
      thermalPaper: '100 * 100',
      content: '',
      isDuplication: false,
      selectOptionsLoading: false,
      data: [],
      isImportData: false, //批量导入弹窗
      importQuantity: false, //批量导入入库数量
      modalInfo: {
        modalTitle: this.$t('form.ImportArrivalDetails'),
        modalDesc: '',
        modalUrl: api.batchImportAdvancedShippingNoteItems,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      },
      modalInfoQuantity: {
        modalTitle: this.$t('form.BatchReceiptQuantity'),
        modalDesc: '',
        modalUrl: api.advancedShippingNoteBatchImportAsnPutAwayQuantity,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      },
      sessionId: '',
      isLoading: false,
      pageNo: 1,
      pageSize: 20,
      pages: '',
      stateData: [],
      curState: [],
      currentGood: {},
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
      purchaseAllQuantity: 0,
      receivedAllQuantity: 0,
      shopCode: '',
      reviewLoading: false,
      confirmFinishLoading: false,
      withdrawalLoading: false,
      voidOrderLoading: false,
      confirmWarehousingLoading: false,
      submitLoading: false,
      // 串码与入库图片弹窗
      imeiModalVisible: false,
      imeiModalSubmitting: false,
      imeiModalRecord: {},
      imeiModalImeiInput: '',
      imeiModalImageList: [],
      imeiModalBattery: '',
      imeiModalAppearance: '',
      imeiModalNote: '',
      // 预计到货时间单独修改
      isEditingEstimatedArrivalTime: false,
      updateEstimatedArrivalTimeLoading: false,
      originalEstimatedArrivalTime: '',
    }
  },
  mounted() {
    this.sessionId = getCookie('d_session_id')
    let currentShop = JSON.parse(localStorage.getItem('currentShop'))
    this.shopCode = currentShop.uniqueCode
    this.init()
  },
  activated() {
    this.init()
  },
  computed: {
    ...mapState(['userSession']),
    ...mapGetters(['isRent']),
    lang() {
      return this.$store.state.lang
    },
    buId() {
      return this.$store.getters.partyId
    },
    shippingList() {
      return [
        {
          shippingName: this.$t(`form.OceanShipping`),
          code: 'OceanShipping',
        },
        {
          shippingName: this.$t(`form.LandTransportation`),
          code: 'LandTransportation',
        },
        {
          shippingName: this.$t(`form.LandSeaMixing`),
          code: 'LandSeaMixing',
        },
      ]
    },
    columns() {
      let list = deepClone(this.stockColumns)
      list.splice(7, 3)
      return list
    },
    disabledColumns() {
      let list = this.stockColumns.filter((item) => item.dataIndex !== 'delect')
      return list
    },
    showColumns() {
      const list = deepClone(
        !this.isEdit
          ? this.columns
          : this.formData.status === 'WAIT_CHECK' || this.formData.status === 'WAIT_INBOUND'
          ? this.stockColumns
          : this.disabledColumns
      )

      if (this.isRent) {
        list.splice(7, 0, {
          title: this.$t('IMEI列表'),
          align: 'center',
          dataIndex: 'imeiList',
          width: 120,
          scopedSlots: {
            customRender: 'imeiList',
          },
        })
        list.splice(8, 0, {
          title: this.$t('入库附件'),
          align: 'center',
          dataIndex: 'shipFiles',
          width: 120,
          scopedSlots: {
            customRender: 'shipFiles',
          },
        })
        // if (this.formData.status === 'WAIT_INBOUND') {
        //   list.push({
        //     title: this.$t(`form.Operation`),
        //     align: 'center',
        //     dataIndex: 'imeiOperation',
        //     width: 150,
        //     scopedSlots: {
        //       customRender: 'imeiOperation',
        //     },
        //   })
        // }
      }
      // console.log('list', list)
      return list
    },
  },
  watch: {
    'formData.changeWarehouseType'(newVal) {
      if (newVal === 'STRATEGY_WAREHOUSE') {
        this.formData.chooseShippingType = 'BEST_SHIIPING'
      }
    },
    tableData: {
      handler: function (data) {
        this.purchaseAllQuantity = data.reduce((a, b) => a + (b.sentQuantity || 0), 0)
        this.receivedAllQuantity = data.reduce(
          (a, b) => a + ((b.putAwayDefectiveQuantity || 0) + (b.putAwayQuantity || 0)),
          0
        )
      },
    },
    editShow(newType) {
      let index = this.stockColumns.findIndex((v) => v.dataIndex === 'delect')
      if (newType) {
        if (index > 0) {
          this.stockColumns.splice(index, 1)
        }
      } else {
        if (index < 0 && this.formData.status !== 'WAIT_INBOUND') {
          this.stockColumns.push({
            slots: { title: 'Operation' },
            align: 'center',
            dataIndex: 'delect',
            width: 120,
            scopedSlots: {
              customRender: 'delect',
            },
          })
        }
      }
    },
    isInfoShow(newType) {
      let list = deepClone(this.stockColumns)
      let index = list.findIndex((v) => {
        return v.dataIndex == 'delect'
      })
      let id = list.findIndex((v) => {
        return v.dataIndex == 'putAwayQuantity'
      })
      if (newType) {
        if (id > 0 && this.formData.status === 'WAIT_CHECK') {
          list.splice(id, 3)
        }
        if (index < 0 && this.formData.status !== 'WAIT_INBOUND') {
          list.push({
            title: this.$t(`form.Action`),
            align: 'center',
            dataIndex: 'delect',
            width: 120,
            scopedSlots: {
              customRender: 'delect',
            },
          })
        }
        this.stockColumns = list
      }
    },
  },
  filters: {
    statusFilter(val) {
      const statusMap = {
        WAIT_CHECK: _self.$t(`form.Pending`),
        WAIT_PUSH: _self.$t(`form.ToBePushed`),
        PUSH_FAIL: _self.$t(`form.PushFailed`),
        WAIT_INBOUND: _self.$t(`form.WaitInbound`),
        PART_INBOUND: _self.$t(`form.PART_INBOUND`),
        FINISH: _self.$t(`form.Success`),
        CANCEL: _self.$t(`form.Abolished`),
      }
      return statusMap[val]
    },
    asnTypeFilter(val) {
      const asnTypeMap = {
        PURCHASE: _self.$t(`form.purchase`),
        TRANSFER: _self.$t(`form.Transfer`),
      }
      return asnTypeMap[val]
    },
  },
  methods: {
    copy,
    Formatter: formatter,
    parseNote(text) {
      if (!text) return null
      if (typeof text !== 'string') return null
      if (text.startsWith('{') && text.endsWith('}')) {
        try {
          const obj = JSON.parse(text)
          if (obj && typeof obj === 'object') {
            return obj
          }
        } catch {
          return text
        }
      }
      return null
    },
    openImeiModal(record) {
      this.imeiModalRecord = record || {}
      if (Array.isArray(record.imeiList)) {
        this.imeiModalImeiInput = record.imeiList.join(' ')
      } else {
        this.imeiModalImeiInput = record.imeiList || ''
      }
      const parsedNote = this.parseNote(record.note)
      if (parsedNote) {
        this.imeiModalBattery = parsedNote.battery || ''
        this.imeiModalAppearance = parsedNote.appearance || ''
        this.imeiModalNote = parsedNote.note || ''
      } else {
        this.imeiModalBattery = record.node?.battery || ''
        this.imeiModalAppearance = record.node?.appearance || ''
        this.imeiModalNote = record.note || record.node?.note || ''
      }
      // 预填已有入库附件（后端可能返回 url 字符串数组 / 或对象数组）
      this.imeiModalImageList = (record.shipFiles || [])
        .map((item, index) => {
          // 兼容：string url
          if (typeof item === 'string') {
            const url = item
            const name = url.split('/').pop() || `file-${index + 1}`
            return {
              uid: `ship-${
                record.advancedShippingNoteItemId || record.asnItemId || 'tmp'
              }-${index}`,
              name,
              status: 'done',
              url,
            }
          }
          // 兼容：{ url, partyFileId, ... }
          if (item && typeof item === 'object') {
            const url = item.url
            const name = item.name || (url ? url.split('/').pop() : `file-${index + 1}`)
            return {
              uid:
                item.uid ||
                item.partyFileId ||
                `ship-${record.advancedShippingNoteItemId || record.asnItemId || 'tmp'}-${index}`,
              name,
              status: item.status || (url ? 'done' : undefined),
              url,
              partyFileId: item.partyFileId,
            }
          }
          return null
        })
        .filter(Boolean)
      this.imeiModalVisible = true
    },
    formatImeiInputToArray(str) {
      if (!str) return []
      return String(str)
        .trim()
        .split(/[,\s，]+/)
        .filter(Boolean)
    },
    async submitImeiModal() {
      if (!this.imeiModalRecord || !this.imeiModalRecord.advancedShippingNoteItemId) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('缺少ASN明细ID，无法更新串码'),
        })
        return
      }
      const imeiList = this.formatImeiInputToArray(this.imeiModalImeiInput)
      const shipFiles =
        this.imeiModalImageList
          ?.map((item) => {
            // 兼容：上传组件返回对象 / 以及直接 string
            if (typeof item === 'string') return item
            if (item && item.url) return item.url
            if (item && item.response && item.response.result && item.response.result.url) {
              return item.response.result.url
            }
            return null
          })
          .filter(Boolean) || []

      this.imeiModalSubmitting = true
      const jsonNode = {
        battery: this.imeiModalBattery,
        appearance: this.imeiModalAppearance,
        note: this.imeiModalNote,
      }
      await http({
        url: api.advancedShippingNoteUpdateImei,
        type: 'post',
        data: {
          asnItemId: this.imeiModalRecord.advancedShippingNoteItemId,
          imeiList,
          shipFiles,
          note: JSON.stringify(jsonNode),
        },
        hasLoading: true,
        success: (res) => {
          if (res && res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t('更新串码与入库图片成功'),
            })
            this.imeiModalVisible = false
            this.getList()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
        },
      })
      this.imeiModalSubmitting = false
    },
    init() {
      this.getList()
      if (this.$route.query.purchaseOrderId) {
        this.getByPOIdForASN()
      }
    },
    refreshHandle() {
      this.init()
    },
    async getByPOIdForASN() {
      this.isInfoShow = true
      this.isLoading = true
      let res = await http({
        url: api.getByPOIdForASN,
        type: 'post',
        data: {
          purchaseOrderId: this.$route.query.purchaseOrderId,
        },
      })
      if (!res.result.poItemForASNResVOS?.length) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('当前采购订单中的所有商品都已入库'),
        })
      }
      this.purchaseOrderSn = res.result.purchaseOrderSn
      this.formData = res.result
      this.formData.associatedOrderSn = res.result.purchaseOrderSn
      this.tableData = (res.result.poItemForASNResVOS || []).map((item) => {
        if (item.imeiList && Array.isArray(item.imeiList)) {
          item.imeiList = item.imeiList.join(' ')
        }
        return item
      })
      this.tableData.forEach((item) => {
        item.editable = true
      })
      this.isLoading = false
    },
    // 搜索采购单号
    purchaseOrderSnChange(purchaseOrderId) {
      if (purchaseOrderId === undefined) {
        this.tableData = []
        this.formData = {}
        this.purchaseOrderSn = null
        return
      }
      http({
        url: api.getByPOIdForASN,
        type: 'post',
        data: {
          purchaseOrderId,
        },
        success: (res) => {
          if (!res.result.poItemForASNResVOS.length) {
            this.$warning({
              title: this.$t(`layer.Warning`),
              content: this.$t('当前采购订单中的所有商品都已入库'),
            })
          }
          this.purchaseOrderSn = res.result.purchaseOrderSn
          this.formData = res.result
          this.isInfoShow = true
          this.formData.associatedOrderSn = res.result.purchaseOrderSn
          this.tableData = (res.result.poItemForASNResVOS || []).map((item) => {
            if (item.imeiList && Array.isArray(item.imeiList)) {
              item.imeiList = item.imeiList.join(' ')
            }
            return item
          })
          this.tableData.forEach((item) => {
            item.editable = true
          })
          // console.log(this.formData.associatedOrderSn, 'ww')
        },
      })
    },
    OrderSnList(orderSn) {
      var _self = this
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      currentValue = orderSn

      if (orderSn === '') {
        return
      }
      function fake() {
        http({
          url: api.listBySearchForASN,
          type: 'post',
          data: {
            purchaseOrderSn: orderSn,
          },
          success: (d) => {
            if (currentValue === orderSn) {
              const orderSn = d.result.purchaseOrderList
              const data = []
              orderSn.forEach((r) => {
                data.push({
                  value: r.purchaseOrderId,
                  label: r.purchaseOrderSn,
                  key: r.purchaseOrderId,
                  text: r.purchaseOrderSn,
                })
              })
              _self.orderSnList = data
            }
          },
        })
      }
      timeout = setTimeout(fake, 300)
    },
    purchaseOrderSnSearch(orderSn) {
      this.OrderSnList(orderSn)
    },
    createForm() {
      http({
        url: api.updateAdvancedShippingNoteInfo,
        type: 'post',
        data: {
          ...this.formData,
        },
        hasLoading: false,
        success() {
          _self.getList()
          _self.isShow = !_self.isShow
        },
      })
    },
    createInfoForm() {
      this.Judgmentduplication()
      if (this.isDuplication) {
        this.isDuplication = false
        return
      }
      this.tableData.forEach((res) => {
        if (!res.sentQuantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`form.StockQuantity`),
          })
          throw Error()
        }
      })
      http({
        url: api.updateAdvancedShippingNoteItems,
        type: 'post',
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
          advancedShippingNoteItemReqVOS: this.formData.advancedShippingNoteItemResVOS,
        },
        hasLoading: false,
        success() {
          _self.getList()
          _self.isInfoShow = !_self.isInfoShow
        },
      })
    },
    async getList() {
      _self = this
      this.isEditingEstimatedArrivalTime = false
      this.inputScopedSlots = ['caseNo', 'caseNum', 'sentQuantity', 'imeiList', 'skuNumber']
      this.customRenderList = [
        'caseNo',
        'caseUnit',
        'caseNum',
        'sentQuantity',
        'imeiList',
        'currency',
        'note',
        'unit',
        'delect',
        'skuNumber',
        'putAwayQuantity',
        'putAwayDefectiveQuantity',
      ]
      if (this.$route.query.id) {
        this.advancedShippingNoteId = this.$route.query.id
        this.getOrderActionList()
        this.editShow = true
        this.isEdit = true
        this.isLoading = true
        let res = await http({
          url: api.advancedShippingNoteDetail,
          type: 'post',
          data: {
            advancedShippingNoteId: this.advancedShippingNoteId,
          },
        })
        this.tableData = (res.result.advancedShippingNoteItemResVOS || [])
          .sort((a, b) => {
            a.skuNumber - b.skuNumber
          })
          .map((item) => {
            if (item.imeiList && Array.isArray(item.imeiList)) {
              item.imeiList = item.imeiList.join(' ')
            }
            return item
          })
        this.formData = res.result
        this.purchaseOrderSn = res.result.purchaseOrderSn
        this.getOrderProcess()
        this.$forceUpdate()
        this.isLoading = false
      } else {
        this.inputScopedSlots = ['caseNo', 'caseNum', 'sentQuantity', 'imeiList', 'skuNumber']
        this.customRenderList = [
          'caseNo',
          'caseNum',
          'sentQuantity',
          'currency',
          'note',
          'unit',
          'delect',
          'skuNumber',
          'imeiList',
          'putAwayQuantity',
          'putAwayDefectiveQuantity',
        ]
      }
    },
    cancelEdit() {
      this.getList()
      this.isShow = !this.isShow
    },
    cancelInfoEdit() {
      this.getList()
      this.isInfoShow = !this.isInfoShow
    },
    getOrderActionList() {
      const _self = this
      http({
        url: api.advancedShippingNoteActionList,
        type: 'post',
        data: {
          advancedShippingNoteId: _self.advancedShippingNoteId,
        },
        hasLoading: false,
        success(res) {
          _self.orderActions = res.result
        },
      })
    },
    chooseEstimatedArrivalTime(data) {
      this.formData.estimatedArrivalTime = data.data
    },
    startEditEstimatedArrivalTime() {
      this.originalEstimatedArrivalTime = this.formData.estimatedArrivalTime
      this.isEditingEstimatedArrivalTime = true
    },
    cancelEditEstimatedArrivalTime() {
      this.formData.estimatedArrivalTime = this.originalEstimatedArrivalTime
      this.isEditingEstimatedArrivalTime = false
    },
    async saveEstimatedArrivalTime() {
      if (!this.formData.estimatedArrivalTime) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('预计到货时间不能为空'),
        })
        return
      }
      const asnId =
        this.formData.advancedShippingNoteId || this.advancedShippingNoteId || this.$route.query.id
      if (!asnId) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('缺少ASN单ID'),
        })
        return
      }
      this.updateEstimatedArrivalTimeLoading = true
      await http({
        url: api.updateAsnEstimatedArrivalTime,
        type: 'post',
        data: {
          asnId: Number(asnId),
          estimatedArrivalTime: this.formData.estimatedArrivalTime,
        },
        hasLoading: true,
        success: (res) => {
          if (res && res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t('修改预计到货时间成功'),
            })
            this.isEditingEstimatedArrivalTime = false
            this.originalEstimatedArrivalTime = this.formData.estimatedArrivalTime
            this.getList()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: res?.msg || this.$t('修改失败'),
            })
          }
        },
      })
      this.updateEstimatedArrivalTimeLoading = false
    },
    handleChangeSku(data) {
      this.currentGood = data
    },
    handleChange(value, rowKey, colName, index) {
      const newData = [...this.tableData]
      const target = newData.filter((item) => rowKey === item.key)[index]
      if (target) {
        target[colName] = value
        this.tableData = newData
        this.formData.advancedShippingNoteItemResVOS = newData
      }
    },
    handleSplit(index) {
      const row = this.tableData[index]
      const count = parseInt(row.sentQuantity)
      if (isNaN(count) || count <= 1) return

      const newRows = []
      const startCaseNo = row.caseNo * 1
      for (let i = 0; i < count; i++) {
        const newRow = deepClone(row)
        newRow.sentQuantity = 1
        if (newRow.advancedShippingNoteItemId) {
          delete newRow.advancedShippingNoteItemId
        }
        if (newRow.asnItemId) {
          delete newRow.asnItemId
        }
        newRow.caseNo = startCaseNo + i
        newRows.push(newRow)
      }

      this.tableData.splice(index, 1, ...newRows)

      // 重新分配后续行的箱号
      for (let i = index + count; i < this.tableData.length; i++) {
        this.tableData[i].caseNo = this.tableData[i - 1].caseNo * 1 + 1
      }
      this.formData.advancedShippingNoteItemResVOS = [...this.tableData]
    },
    // select 框 change
    onChangeSelect($event, rowKey, colName, index) {
      const newData = [...this.tableData]
      const target = newData.filter((item) => rowKey === item.key)[index]

      if (target) {
        target[colName] = $event
        // 根据select框的值自动带出某个input的值 - 因为第三列列名为c
        // $event === '1小时' ? target.c = '根据1小时带出的值' : target.c = '根据2小时带出的值'
        this.tableData = newData
      }
    },
    onDelect(index) {
      const newData = [...this.tableData]
      newData.splice(index, 1)
      this.tableData = newData
      this.formData.advancedShippingNoteItemResVOS = newData
    },
    addGoodsToTable() {
      if (this.currentGood.skuName) {
        this.currentGood.caseNo =
          this.tableData.length == 0 ? 1 : this.tableData[this.tableData.length - 1].caseNo * 1 + 1
        this.currentGood.productName = this.currentGood.skuName
        this.currentGood.productStyle = this.currentGood.skuStyleValue
        this.currentGood.unit = '个'
        this.currentGood.editable = true
        this.tableData.push({ ...this.currentGood })
        // console.log(this.tableData)
      }
    },
    selectedWarehouse(data) {
      if (!data) return
      this.formData.warehouseName = data.name
    },
    onEdit() {
      this.editShow = false
      this.isEdit = false
      this.tableData.forEach((item) => {
        item.editable = true
      })
    },
    onSubmit: debounce(function () {
      if (!this.formData.purchaseOrderSn) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t(`layer.PleasePONo`),
        })
        return
      }
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      if (!this.formData.supplierName) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t(`layer.PleaseSupplier`),
        })
        return
      }
      this.tableData.forEach((res) => {
        if (!res.sentQuantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`form.StockQuantity`),
          })
          throw Error()
        }
      })
      this.Judgmentduplication()
      if (this.isDuplication) {
        this.isDuplication = false
        return
      }
      if (this.advancedShippingNoteId) {
        this.updateAdvancedShippingNoteInfo(this.formData)
        this.updateAdvancedShippingNoteItems()
      } else {
        const data = deepClone(this.formData)
        data.advancedShippingNoteItemReqVOS = deepClone(this.tableData).map((item) => {
          item.imeiList =
            (item.imeiList && item.imeiList?.replaceAll(' ', ',')?.split(',')?.filter(Boolean)) ||
            null
          return item
        })
        data.advancedShippingNoteId = this.advancedShippingNoteId
        data.associatedOrderSn = this.purchaseOrderSn
        // console.log(data)
        // return
        this.submitLoading = true
        http({
          url: api.advancedShippingNoteSave,
          data,
          type: 'post',
          hasLoading: true,
          success: (res) => {
            this.submitLoading = false
            if (res.success && res.result.advancedShippingNoteId) {
              this.$success({
                title: this.$t(`layer.Success`),
                content: _self.$t(`layer.SavingSucceeded`),
              })
              this.$router.push('/advancedShippingNote')
            } else {
              this.$error({
                title: this.$t(`layer.Error`),
                content: this.$t('layer.CreateFailed'),
              })
            }
          },
          fail: (res) => {
            this.submitLoading = false
            this.$error(res.msg)
          },
        })
      }
    }),
    // 用来判断一个箱号是否存在多个sku
    Judgmentduplication() {
      let tempData = [...this.tableData]
      var map = {},
        dest = []
      for (var i = 0; i < tempData.length; i++) {
        var ai = tempData[i]
        if (!map[ai.caseNo]) {
          dest.push({
            caseNo: ai.caseNo,
            barcode: ai.barcode,
            editable: ai.editable,
            productName: ai.productName,
            productStyle: ai.productStyle,
            sentQuantity: ai.sentQuantity,
            unit: ai.unit,
            data: [ai],
          })
          map[ai.caseNo] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.caseNo == ai.caseNo) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      // console.log(dest)
      let repeatArr = []
      dest.forEach((v) => {
        duplicates(v.data)
      })

      function duplicates(arr) {
        var Arr = []
        for (let i = 0; i < arr.length; i++) {
          for (let j = i + 1; j < arr.length; j++) {
            if (arr[i].barcode === arr[j].barcode && Arr.indexOf(arr[j].barcode) === -1) {
              Arr.push(arr[i].caseNo)
            }
          }
          if (Arr.length > 0) {
            repeatArr.push(...Arr)
          }
        }
      }
      if (repeatArr.length > 0) {
        this.isDuplication = true
        let tempArr = Array.from(new Set(repeatArr))
        let str = _self.$t(`layer.TheCaseNumberIs`)
        str += tempArr.join('、')
        str += _self.$t(`layer.BarcodeRepeated`) + _self.$t(`layer.CheckAndModify`)
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: str,
        })
      }
    },
    updateAdvancedShippingNoteInfo(data) {
      data.advancedShippingNoteId = this.advancedShippingNoteId
      http({
        url: api.updateAdvancedShippingNoteInfo,
        data,
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.advancedShippingNoteId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    updateAdvancedShippingNoteItems() {
      http({
        url: api.updateAdvancedShippingNoteItems,
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
          advancedShippingNoteItemReqVOS: this.tableData,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.advancedShippingNoteId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    async onReview() {
      this.reviewLoading = true
      await http({
        url: api.advancedShippingNoteCheck,
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.advancedShippingNoteId) {
            this.getOrderProcess()
            this.getList()
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`form.AUDIT_SUCCESS`),
            })
            this.formData.status = res.result.status
          } else {
            this.getOrderProcess()
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
          this.getOrderActionList()
        },
      })
      this.reviewLoading = false
    },
    async onConfirmFinish() {
      this.confirmFinishLoading = true
      await http({
        url: api.advancedShippingNoteFinish,
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.advancedShippingNoteId) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.OrderClosed`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
          this.getOrderActionList()
        },
      })
      this.confirmFinishLoading = false
    },
    // 退审
    async onWithdrawal() {
      this.withdrawalLoading = true
      await http({
        url: api.advancedShippingNoteRevertCheck,
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.advancedShippingNoteId) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.OrderWithdrawaled`),
            })
            this.$router.back()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.WithdrawalFailed'),
            })
          }
          this.getOrderActionList()
        },
      })
      this.withdrawalLoading = false
    },
    async onVoidOrder() {
      if (this.isRent && this.formData.asnType === 'TRANSFER') {
        this.$warning({
          title: this.$t('form.Tips'),
          content: this.$t('该单据为调拨单且为租机业务，暂不支持作废'),
        })
        return
      }
      this.voidOrderLoading = true
      await http({
        url: api.advancedShippingNoteCancel,
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.advancedShippingNoteId) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.OrderVoided`),
            })
            this.$router.back()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
          this.getOrderActionList()
        },
      })
      this.voidOrderLoading = false
    },
    // 手动入库
    onManualImport() {
      if (this.formData.receivingOrderSn) {
        // 有入库单号,点手动入库跳转hub收货
        window.open('/order/purchaseReceipts?asn_sn=' + this.formData.advancedShippingNoteSn)
        this.isInfoShow = false
        return
      }
      this.isInfoShow = true
      this.inputScopedSlots = ['putAwayQuantity', 'putAwayDefectiveQuantity', 'imeiList']
      this.customRenderList = [
        'caseNo',
        'caseUnit',
        'caseNum',
        'sentQuantity',
        'imeiList',
        'currency',
        'note',
        'unit',
        'delect',
        'skuNumber',
        'putAwayQuantity',
        'putAwayDefectiveQuantity',
      ]
    },
    // 全部入库
    onWarehousingAll() {
      let newData = [...this.tableData]
      newData.forEach((v) => {
        v.differentCount = 0
        v.putAwayQuantity = v.sentQuantity
      })
      this.tableData = [...newData]
    },
    // 确认入库
    async onConfirmWarehousing() {
      if (this.isRent) {
        const errorItem = this.tableData.find(
          (v) =>
            ((v.putAwayQuantity || 0) > 0 || (v.putAwayDefectiveQuantity || 0) > 0) && !v.imeiList
        )
        if (errorItem) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: `请输入箱号为${errorItem.caseNo}的IMEI列表`,
          })
          return
        }
      }
      this.confirmWarehousingLoading = true
      await http({
        url: api.advancedShippingNoteConfirmNewAsnInfoByVirtualWms,
        data: {
          advancedShippingNoteId: this.advancedShippingNoteId,
          items: [...this.tableData],
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            // this.getOrderProcess();
            this.getList()
            _self.isInfoShow = !_self.isInfoShow
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.WarehousingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.WarehousingFailed'),
            })
          }
          // this.getOrderActionList();
        },
      })
      this.confirmWarehousingLoading = false
    },
    backForm() {
      this.$router.back()
    },
    onSelectChange(selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    // 输入箱号
    selectCaseNo(e) {
      let val = e.target.value
      let section = []
      if (val.indexOf('-') !== -1) {
        section = val.split('-')
      } else if (val.indexOf(' ')) {
        section = val.split(' ')
      }
      let tempData = [...this.tableData]
      let selectArr = []
      if (section[0] < section[1]) {
        tempData.forEach((v, i) => {
          if (section[0] * 1 <= v.caseNo && v.caseNo <= section[1] * 1) {
            selectArr.push(i)
          }
        })
      } else if (section[0] > section[1]) {
        tempData.forEach((v, i) => {
          if (section[1] * 1 <= v.caseNo && v.caseNo <= section[0] * 1) {
            selectArr.push(i)
          }
        })
      } else if (section[0] === section[1]) {
        tempData.forEach((v, i) => {
          if (section[1] * 1 == v.caseNo) {
            selectArr.push(i)
          }
        })
      }
      this.selectedRowKeys = selectArr
    },
    // 打印箱唛弹窗出现
    showMarkModal() {
      if (this.selectedRowKeys.length === 0) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.selectCaseNumber`),
        })
        return
      }
      this.isShowMark = true
    },
    // 筛选箱号
    screeningcaseNo() {
      let tempData = [...this.tableData]
      let newData = []
      let map = {}
      let dest = []
      this.selectedRowKeys.forEach((v) => {
        newData.push(tempData[v])
      })
      for (var i = 0; i < newData.length; i++) {
        var ai = newData[i]
        if (!map[ai.caseNo]) {
          dest.push({
            caseNo: ai.caseNo,
            barcode: ai.barcode,
            editable: ai.editable,
            productName: ai.productName,
            productStyle: ai.productStyle,
            sentQuantity: ai.sentQuantity,
            unit: ai.unit,
            data: [ai],
          })
          map[ai.caseNo] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.caseNo == ai.caseNo) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      let newKeys = [] //接口传递箱号
      dest.forEach((v) => {
        newKeys.push(v.caseNo)
      })
      return newKeys
    },
    // 导出pdf
    exportPdf() {
      this.isLoading = true
      this.isShowMark = false
      fetch(api.exportShippingMark, {
        method: 'POST',
        body: {
          advancedShippingNoteId: this.advancedShippingNoteId,
          caseNoList: [...this.screeningcaseNo()],
          pageHeight: this.thermalPaper.split('*')[1] * 1,
          pageWidth: this.thermalPaper.split('*')[0] * 1,
          shopCode: this.shopCode,
        },
      }).then((res) => {
        if (res.result.taskId) {
          this.$message.success(this.$t('创建导出任务成功,请前往【数据中心/下载中心】下载'))
        } else {
          this.$message.error(res.msg)
        }
        this.isLoading = false
      })
    },
    // 预览pdf
    previewPdf() {
      fetch(api.shippingMarkPreview, {
        method: 'POST',
        body: {
          advancedShippingNoteId: this.advancedShippingNoteId,
          caseNoList: [...this.screeningcaseNo()],
        },
        responseType: 'blob',
      }).then((blob) => {
        // console.log(blob)
        var a = document.createElement('a') //创建一个<a></a>标签
        a.href = URL.createObjectURL(blob) // 将流文件写入a标签的href属性值
        a.target = '_blank'
        a.style.display = 'none' // 障眼法藏起来a标签
        document.body.appendChild(a) // 将a标签追加到文档对象中
        a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove() // 一次性的，用完就删除a标签
        URL.revokeObjectURL(blob)
      })
    },
    // 数组对象根据箱号以及barcode去重方法
    arrayUnique(arr) {
      // 缓存用于记录
      const cache = []
      for (const t of arr) {
        // 检查缓存中是否已经存在
        let index = cache.findIndex((c) => c.caseNo === t.caseNo && c.barcode === t.barcode)
        if (index >= 0) {
          cache[index] = { ...t }
        } else {
          // 不存在就说明以前没遇到过，把它记录下来
          cache.push(t)
        }
      }
      // 记录结果就是过滤后的结果
      return cache
    },
    showModalFn() {
      this.isImportData = true
      this.modalInfo.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/advancedShippingNote/%E9%A2%84%E5%88%B0%E8%B4%A7%E9%80%9A%E7%9F%A5%E5%8D%95%E6%98%8E%E7%BB%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
          : this.$i18n.locale == 'en'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/advancedShippingNote/AdvancedShippingNoteItemTemplate.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/advancedShippingNote/AdvancedShippingNoteItemTemplate.xlsx'
          : ''
    },
    showModalQuantityFn() {
      this.importQuantity = true
      this.modalInfoQuantity.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://erp-prod.oss-ap-southeast-1.aliyuncs.com/cloud_bird_oss_gRDnXV93qPU2SDCp/SCM/20230310/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%A2%84%E5%88%B0%E8%B4%A7%E9%80%9A%E7%9F%A5%E5%8D%95%E5%88%B0%E8%B4%A7%E6%95%B0%E9%87%8F20230310.xlsx'
          : this.$i18n.locale == 'en'
          ? 'https://erp-prod.oss-ap-southeast-1.aliyuncs.com/cloud_bird_oss_gRDnXV93qPU2SDCp/SCM/20230310/import%20asn%20put%20away%20quantity%2020230310.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://erp-prod.oss-ap-southeast-1.aliyuncs.com/cloud_bird_oss_gRDnXV93qPU2SDCp/SCM/20230310/import%20asn%20put%20away%20quantity%2020230310.xlsx'
          : ''
    },
    // 导入商品信息数据
    importData(info) {
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          // 导入的数据
          let resultArr = info.fileList[info.fileList.length - 1].response.result.items
          // push到表格列表中
          this.tableData.push(...resultArr)
          let newData = [...this.tableData]
          this.tableData = [...this.arrayUnique(newData)]
          this.formData.advancedShippingNoteItemReqVOS = this.tableData
          this.isInfoShow = true
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.isImportData = false
    },
    // 导入当前入库数量
    importQuantityFn(info) {
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          // 导入的数据
          let resultArr = info.fileList[info.fileList.length - 1].response.result.items
          // console.log(resultArr)
          let newData = [...this.tableData]
          newData.forEach((v) => {
            resultArr.forEach((item) => {
              if (v.caseNo == item.caseNo && v.barcode == item.barcode) {
                // v.receivedQuantity = item.putAwayQuantity
                v.putAwayQuantity = item.putAwayQuantity
                v.putAwayDefectiveQuantity = item.putAwayDefectiveQuantity
              }
            })
          })
          this.tableData = [...newData]
          this.formData.advancedShippingNoteItemReqVOS = this.tableData
          this.isInfoShow = true
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.importQuantity = false
    },
    // 批量删除sku
    batchDelFn() {
      if (this.selectedRowKeys.length === 0) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.SelectAtLeastOneItem`),
        })
        return
      }
      this.tableData = this.tableData.filter((item, index) => {
        return !this.selectedRowKeys.includes(index)
      })
      this.formData.advancedShippingNoteItemResVOS = this.tableData
      this.selectedRowKeys = []
    },
    getOrderProcess() {
      this.stateData = [
        {
          state: 'create',
          name: 'Create', //创建
          time: this.formData.orderTime,
          status: this.formData.status,
        },
        {
          state: 'check',
          name: 'Review', //审核
          time: this.formData.status == undefined ? '' : this.formData.checkTime,
          status: this.formData.status,
        },
        {
          state: 'push',
          name: 'Push', //推送
          time: this.formData.status == undefined ? '' : this.formData.pushTime,
          status: this.formData.status,
        },
        {
          state: 'Warehousing',
          name: 'Warehousing', //入库
          time: this.formData.status == undefined ? '' : this.formData.arrivalTime,
          status: this.formData.status,
        },
        {
          state: 'Complete',
          name: 'Complete', //完成
          time: this.formData.finishTime,
          status: this.formData.status,
        },
      ]

      if (this.formData.status == 'CANCEL') {
        this.curState = {
          state: '',
        }
      } else if (this.formData.status == 'WAIT_INBOUND') {
        this.curState = {
          state: 'push',
        }
      } else if (this.formData.status == 'PART_INBOUND') {
        this.curState = {
          state: 'Warehousing',
        }
        this.stateData[this.stateData.length - 1].time = ''
      } else if (this.formData.status == 'WAIT_PUSH' || this.formData.status == 'PUSH_FAIL') {
        this.curState = {
          state: 'check',
        }
      } else if (this.formData.status === 'FINISH') {
        this.curState = {
          state: 'Complete',
        }
      }
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    getDiffCount(record) {
      let num = record.putAwayDefectiveQuantity + record.putAwayQuantity - record.sentQuantity
      this.formData.status === 'PART_INBOUND' ||
      this.formData.status === 'FINISH' ||
      this.formData.status === 'WAIT_INBOUND'
        ? isNaN(num)
          ? ''
          : num > 0
          ? '+' + num
          : num
        : ''
      return num
    },
    mergeCells(text, data, key, index) {
      // 上一行该列数据是否一样
      if (index !== 0 && text === data[index - 1]?.[key]) {
        return 0
      }
      let rowSpan = 1
      // 判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break
        }
        rowSpan++
      }
      return rowSpan
    },
    customCell(record, index) {
      let rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
      return rowSpan > 0
        ? {
            attrs: {
              rowSpan,
            },
          }
        : {
            style: {
              display: 'none',
            },
            attrs: {
              rowSpan: 0,
            },
          }
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixContent {
  height: calc(100vh);
  overflow-y: auto;
  overflow-x: hidden;
  width: 1200px;
  // display: flex;
  // justify-content: space-between;
}
.node-modal {
  font-size: 22px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
  height: 90%;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
</style>
